import dayjsTZ from "../../utils/dayjs";
import {
  wages as wagesAction,
  prepayments as prepaymentsAction,
  earnings as earningsAction,
  deductions as deductionsAction,
  employeeRequests as employeeRequestsAction,
  candidates as candidatesAction,
} from "../../store/actions";
import { requestData, requestDataWithParams } from "./RequestFactory";

/**
 * Fetch payroll / request tables on demand (not at login bootstrap).
 * Skips tables already present in Redux.
 */
export async function ensureDeferredTables(dispatch, present, needed = []) {
  const tasks = [];

  const want = new Set(needed);

  if (want.has("wages") && !present.wages) {
    tasks.push(async () => {
      const start = dayjsTZ().subtract(14, "months").startOf("month").valueOf();
      const end = dayjsTZ().endOf("month").valueOf();
      const res = await requestDataWithParams("wages", start, end);
      if (res) dispatch(wagesAction(res));
      return res;
    });
  }

  if (want.has("prepayments") && !present.prepayments) {
    tasks.push(async () => {
      const start = dayjsTZ().subtract(14, "months").startOf("month").valueOf();
      const end = dayjsTZ().endOf("month").valueOf();
      const res = await requestDataWithParams("prepayments", start, end);
      if (res) dispatch(prepaymentsAction(res));
      return res;
    });
  }

  if (want.has("earnings") && !present.earnings) {
    tasks.push(async () => {
      const res = await requestData("earnings");
      if (res) dispatch(earningsAction(res));
      return res;
    });
  }

  if (want.has("deductions") && !present.deductions) {
    tasks.push(async () => {
      const res = await requestData("deductions");
      if (res) dispatch(deductionsAction(res));
      return res;
    });
  }

  if (want.has("employeeRequests") && !present.employeeRequests) {
    tasks.push(async () => {
      const start = dayjsTZ().subtract(2, "years").valueOf();
      const res = await requestDataWithParams("employeeRequests", start, null);
      if (res) dispatch(employeeRequestsAction(res));
      return res;
    });
  }

  if (want.has("interviews") && !present.candidates) {
    tasks.push(async () => {
      const res = await requestData("interviews");
      if (res) dispatch(candidatesAction(res));
      return res;
    });
  }

  await Promise.all(tasks.map((t) => t().catch((e) => console.error(e))));
}

/** Report type → tables required before GeneratePage can render. */
export function tablesForReport(reportType) {
  switch (reportType) {
    case "requests":
    case "leaveBalance":
    case "leaveCoverage":
      return ["employeeRequests"];
    case "bankForwardPay":
    case "detailedTaxes":
      return ["wages"];
    case "prepayments":
      return ["prepayments"];
    case "approvals":
    case "supervisorApprovals":
    case "clockingTypesReports":
    case "openForgottenShifts":
    case "missingPunches":
    case "plannedVsActual":
    case "otBank":
    case "hoursCostByDept":
    case "employeesLeave":
      return [];
    case "employeesList":
    case "suspensions":
      return [];
    default:
      return [];
  }
}
